import React from 'react';
import { Icon } from '../Icon';
import { Tooltip } from '../Tooltip';
import * as S from './styled';
export const Tag = ({ label, appearance = 'default', icon, tooltip, size = 'small', hoverable = false, display = 'flex', }) => {
    const tag = (React.createElement(S.Container, { "$appearance": appearance, "$size": size, "$hoverable": hoverable, "$display": display },
        React.createElement("span", null, label),
        icon && React.createElement(Icon, { component: icon, height: 10 })));
    if (!tooltip) {
        return tag;
    }
    return (React.createElement(Tooltip, { reference: tag, placement: "top", strategy: "fixed" }, tooltip));
};
//# sourceMappingURL=Tag.js.map